import { gql } from '@apollo/client';

export const EDIT_DESIGN = gql`
    mutation updateDesign($designId: ID!, $input: DesignUpdateInput!) {
        updateDesign(designId: $designId, input: $input) {
            _id
            name
            design
            marketPlaceType
            ownerId
        }
    }
`